const getTokenLogoURL = (address: string) => {
  return address === '0x08Aed8578dAaBf12d48031fA5d9727e4afD42dee'
    ? '/images/tokens/cheeseLogo.png'
    : `https://assets.trustwalletapp.com/blockchains/smartchain/assets/${address}/logo.png`
}

export default getTokenLogoURL
